/// REACT store.js
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer, createTransform } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // Use local storage
import authReducer from './reducers/authReducer';
import widgetReducer from './reducers/widgetReducer';
import demoModeReducer from './reducers/demoModeReducer';
import debugModeReducer from './reducers/debugModeReducer';
import portfolioReducer, { getPortfolioData, getDataParameters, getPortfolioESGData, getFavoritesESGData, setFilteredTickers, setFilteredTickersF, favoritesReducer  } from './reducers/portfolioReducer';
import trendsearchReducer, { getAlertRelatedTrendsearchData } from './reducers/trendsearchReducer';
import etfReducer from './reducers/etfReducer';
import { fetchEtfData } from './actions/etfActions'; // Import fetchEtfData
// import pfalertReducer from './reducers/pfalertReducer';

// DAS-2620: a persisted status of 'loading' is a ghost after a page reload — no fetch is
// actually in flight. Left as-is, the DAS-2596 dedup guard (condition: status !== 'loading')
// skips every future getPortfolioData dispatch forever, so portfolio.data never loads and
// the Portfolio / Portfolio Analysis buttons never appear (and a refresh can't rescue it,
// since the stale 'loading' is restored every time). Reset any '...loading' status back to
// 'idle' during rehydration so the first fetch after load is allowed to run.
const resetStuckLoadingTransform = createTransform(
  (inboundState) => inboundState,          // persist unchanged
  (outboundState) => {                     // on rehydrate: heal stuck 'loading'
    if (outboundState && typeof outboundState === 'object') {
      const healed = { ...outboundState };
      for (const key of Object.keys(healed)) {
        if (healed[key] === 'loading') healed[key] = 'idle';
      }
      return healed;
    }
    return outboundState;
  },
  { whitelist: ['portfolio', 'favorites'] }
);

// Redux Persist Configuration
const persistConfig = {
  key: 'root',
  storage,
  transforms: [resetStuckLoadingTransform],
};

const rootReducer = combineReducers({
  etf: etfReducer,
  portfolio: portfolioReducer,
  auth: authReducer,
  favorites: favoritesReducer,
  trendsearch_data: trendsearchReducer,
  widget: widgetReducer,
  // pfalert: pfalertReducer,
  demoMode: demoModeReducer,
  debugMode: debugModeReducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false,
  }),
});

const persistor = persistStore(store);

// store.subscribe(() => console.log('Current state:', store.getState()));

export { getPortfolioData, getDataParameters, getPortfolioESGData, getFavoritesESGData, setFilteredTickers, setFilteredTickersF, fetchEtfData, getAlertRelatedTrendsearchData, persistor };

export default store;


